import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faExclamationTriangle, faEnvelope, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom'; // Import Link from react-router-dom
import '../style/Sidebar.css';


const Sidebar = ({ selected, onLogout }) => {
    const navigate = useNavigate();

    const handleLogout = () => {
        // Удаляем токен из localStorage
        localStorage.removeItem('token');
        // Перенаправляем на страницу логина
        navigate('/login');
        window.location.reload();
    };

    return (
        <nav className="sidebar">
            <div className="logo">
                <img src="kmf_logo.png" alt="AlertApp Logo" />
            </div>
            <ul className="menu">
                <li className={`menu-item ${selected === 'dashboards' ? 'selected' : ''}`}>
                    <Link to="/dashboard" className="menu-link">
                        <FontAwesomeIcon icon={faBell} className="icon"/>
                        <span>Обращения</span>
                        <FontAwesomeIcon icon="chevron-right" className="arrow"/>
                    </Link>
                </li>
                <li className={`menu-item ${selected === 'emergency' ? 'selected' : ''}`}>
                    <Link to="/critical-notification" className="menu-link">
                        <FontAwesomeIcon icon={faExclamationTriangle} className="icon"/>
                        <span>Отправить экстренное оповещение</span>
                        <FontAwesomeIcon icon="chevron-right" className="arrow"/>
                    </Link>
                </li>
                <li className={`menu-item ${selected === 'notifications' ? 'selected' : ''}`}>
                    <Link to="/push-notification" className="menu-link">
                        <FontAwesomeIcon icon={faEnvelope} className="icon"/>
                        <span>Отправить уведомление</span>
                        <FontAwesomeIcon icon="chevron-right" className="arrow"/>
                    </Link>
                </li>
                <li className={`menu-item ${selected === 'instructions' ? 'selected' : ''}`}>
                    <Link to="/instructions" className="menu-link">
                        <FontAwesomeIcon icon="fa-solid fa-chalkboard-user" className="icon"/>
                        <span>Памятки</span>
                        <FontAwesomeIcon icon="chevron-right" className="arrow"/>
                    </Link>
                </li>
                <li className={`menu-item ${selected === 'instructions' ? 'selected' : ''}`}>
                    <Link to="/points" className="menu-link">
                        <FontAwesomeIcon icon="fa-solid fa-chalkboard-user" className="icon"/>
                        <span>ПППН</span>
                        <FontAwesomeIcon icon="chevron-right" className="arrow"/>
                    </Link>
                </li>
                <li className={`menu-item ${selected === 'news' ? 'selected' : ''}`}>
                    <Link to="/news" className="menu-link">
                        <FontAwesomeIcon icon="fa-solid fa-chalkboard-user" className="icon"/>
                        <span>Новости</span>
                        <FontAwesomeIcon icon="chevron-right" className="arrow"/>
                    </Link>
                </li>
            </ul>
            <button className="logout" onClick={handleLogout}>
                <span>Выйти с аккаунта</span>
                <FontAwesomeIcon icon={faSignOutAlt} className="arrow"/>
            </button>
        </nav>
    );
};


export default Sidebar;
